import './quasar.sass'
import '@quasar/extras/material-icons/material-icons.css'
import Notify from 'quasar/src/plugins/notify/Notify.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';

// Configuration for the Quasar Vue CLI plugin
export default {
  config: {
    notify: {}, 
  },
  plugins: {
    Notify,
    Dialog
  }
}